import { useConsultContext, useDoctorContext } from "../contexts";
import {
	DoctorsTable,
	TelehealthDashboard
} from "../components/TelehealthQueue";

export const TelehealthDoctors = () => {
	const { consults, completedConsultsCount } = useConsultContext();
	const { activeTelehealthDoctors } = useDoctorContext();

	return (
		<div className="flex flex-col gap-6">
			<div className="ch-l-text mt-4">Telehealth Doctors</div>
			<TelehealthDashboard
				consultCount={consults.length}
				doctorCount={activeTelehealthDoctors?.length || 0}
				completedCounsultCount={completedConsultsCount}
			/>
			<DoctorsTable />
		</div>
	);
};
